"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DocumentServiceImpl = void 0;
var DocumentProviderImpl_1 = require("./provider/airabbi/DocumentProviderImpl");
var DocumentServiceImpl = (function () {
    function DocumentServiceImpl(cfg) {
        this.cfg = cfg;
        this.provider = new DocumentProviderImpl_1.DocumentProviderImpl(cfg);
    }
    DocumentServiceImpl.prototype.init = function (env, cfg) {
        this.env = env;
        if (cfg) {
            this.cfg = cfg;
        }
        return this.provider.init(env);
    };
    DocumentServiceImpl.prototype.setDebuggable = function (debuggable) {
        if (this.cfg) {
            this.cfg.debuggable = debuggable;
        }
        this.provider.setDebuggable(debuggable);
    };
    DocumentServiceImpl.prototype.createDocument = function (document) {
        return this.provider.createDocument(document);
    };
    DocumentServiceImpl.prototype.getDocument = function (documentId) {
        return this.provider.getDocument(documentId);
    };
    DocumentServiceImpl.prototype.getDocuments = function () {
        return this.provider.getDocuments();
    };
    DocumentServiceImpl.prototype.removeDocument = function (documentId) {
        return this.provider.removeDocument(documentId);
    };
    DocumentServiceImpl.prototype.updateDocument = function (document) {
        return this.provider.updateDocument(document);
    };
    DocumentServiceImpl.prototype.stopAllMonitor = function () {
        return this.provider.stopAllMonitor();
    };
    return DocumentServiceImpl;
}());
exports.DocumentServiceImpl = DocumentServiceImpl;
//# sourceMappingURL=DocumentServiceImpl.js.map